import { render, staticRenderFns } from "./MessagePanel.vue?vue&type=template&id=53648614&scoped=true&"
import script from "./MessagePanel.vue?vue&type=script&lang=ts&"
export * from "./MessagePanel.vue?vue&type=script&lang=ts&"
import style0 from "./MessagePanel.vue?vue&type=style&index=0&id=53648614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53648614",
  null
  
)

export default component.exports